import { render, staticRenderFns } from "./create-data-object-modal.vue?vue&type=template&id=b4d12632"
import script from "./create-data-object-modal.vue?vue&type=script&lang=js"
export * from "./create-data-object-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports